import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import CustomModal from "./components/CustomModal/CustomModal";
import { FREE_UPLOAD_LIMIT } from "../../utils/general";

import "./upgrade-modal-content.css";

const PRODUCT_ID_DEV_TINY = "prod_OaDEo0F1lj38QD";
const PRODUCT_ID_PROD_TINY = "prod_OaDIHVQwiyvU0k";

const UpgradeModal = ({
  show,
  cta,
  onClick,
  onHide,
  userProfile,
  modalContext = "publish",
}) => {
  const [modalContent, setModalContent] = useState({
    title: "You've reached your daily upload limit",
    desc: `You can only edit your project ${FREE_UPLOAD_LIMIT} times per day, please upgrade or return tomorrow.`,
  });

  useEffect(() => {
    if (modalContext === "ai-chat") {
      setModalContent({
        title: "Upgrade to use the AI Editor",
        desc: "AI Chat is available on Solo plans and above. Please upgrade to continue.",
      });
      return;
    }

    // Determine content based on user profile
    if (
      userProfile &&
      [PRODUCT_ID_DEV_TINY, PRODUCT_ID_PROD_TINY].includes(
        userProfile.productId,
      )
    ) {
      setModalContent({
        title: "Please upgrade to publish your changes",
        desc: "Editing HTML documents is not available on your current plan. Please upgrade for unlimited edits.",
      });
    } else {
      setModalContent({
        title: "You've reached your daily upload limit",
        desc: `You can only edit your project ${FREE_UPLOAD_LIMIT} times per day, please upgrade or return tomorrow.`,
      });
    }
  }, [userProfile, modalContext]);

  const handleClick = () => {
    onClick();
    onHide();
  };

  return (
    <CustomModal
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      dialogClassName="upgrade-modal-content"
      backdropClassName="upgrade-modal-backdrop"
      centered
    >
      <div className="round-24 bg-white flex">
        <div className="p-4">
          <h2 className="mb-2 bold color-purple-2 font-22">
            {modalContent.title}
          </h2>
          <p className="grey">{modalContent.desc}</p>

          <Button
            className="mt-3 tr-upgrade-card-cta float-end"
            variant="purple"
            onClick={handleClick}
          >
            {cta || "Upgrade"} →
          </Button>
        </div>
        <div
          style={{ width: 200 }}
          className="upgrade-modal-img upgrade-bg-purple"
        ></div>
      </div>
    </CustomModal>
  );
};

export default UpgradeModal;
